/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import PropTypes from 'prop-types';
import React from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import { RIGHT } from 'Component/ChevronIcon/ChevronIcon.config';
import Link from 'Component/Link';
import {
    MenuItem as SourceMenuItem
} from 'SourceComponent/MenuItem/MenuItem.component';

import './MenuItem.override.style';

/** @namespace PeggysagePwa/Component/MenuItem/Component */
export class MenuItemComponent extends SourceMenuItem {
    static propTypes = {
        ...SourceMenuItem.propTypes,
        isButton: PropTypes.bool.isRequired
    };

    renderItemButtonContent() {
        const {
            item,
            itemMods,
            onItemClick
        } = this.props;

        const {
            item_id
        } = item;

        const className = this.getClassName(item);

        return (
            <button
              type="button"
              block="Menu"
              elem="Link"
              id={ `menu-link-${item_id}` }
              onClick={ onItemClick }
              className={ className }
            >
                { this.renderItemContent(item, itemMods) }
            </button>
        );
    }

    /**
     * Override: replace +/- by chevron
     * @returns {JSX.Element|null}
     */
    renderExpandButton() {
        const { isExpandable, itemMods } = this.props;

        if (!isExpandable) {
            return null;
        }

        return (
            <figcaption
              block="Menu"
              elem="ExpandedState"
              mods={ itemMods }
            >
                <ChevronIcon direction={ RIGHT } />
            </figcaption>
        );
    }

    getClassName(item) {
        const {
            category_id = ''
        } = item;

        const classNames = [];

        if (category_id) {
            classNames.push(`menu-link-category-${category_id}`);
        }

        return classNames.join(' ');
    }

    /**
     * Override: valid attribute id (not just number)
     * @returns {JSX.Element}
     */
    renderItemLinkContent() {
        const {
            activeMenuItemsStack,
            item,
            itemMods,
            handleCategoryHover,
            handleLinkLeave,
            onItemClick
        } = this.props;

        const {
            url,
            item_id
        } = item;

        const isHovered = activeMenuItemsStack.includes(item_id);
        const className = this.getClassName(item);

        return (
            <Link
              to={ url }
              block="Menu"
              elem="Link"
              id={ `menu-link-${item_id}` }
              onMouseEnter={ handleCategoryHover }
              onMouseLeave={ handleLinkLeave }
              mods={ { isHovered } }
              className={ className }
              onClick={ onItemClick }
            >
                { this.renderItemContent(item, itemMods) }
            </Link>
        );
    }

    /**
     * OVerride
     * @returns {JSX.Element|*}
     */
    render() {
        const { isButton } = this.props;

        if (isButton) {
            return this.renderItemButtonContent();
        }

        return super.render();
    }
}

export default MenuItemComponent;
